module.exports = __webpack_public_path__ + "static/media/11.6803e4e0.png";